import { RouteComponent, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import backendRoleConfig from '../backendRoleConfig';
import commission from '../commission';
import deferredPayment from '../deferredPayment';
import dictionary from '../dictionary';
import assistenzaNetwork from '../assistenzaNetwork';
import assistenzaVillaggi from '../assistenzaVillaggi';
import mailSentLog from '../mailSentLog';
import network from '../network';
import projectConfig from '../projectConfig';
import purchase from '../purchase';
import qualificationConfig from '../qualificationConfig';
import shopOffer from '../shopOffer';
import dashboard from '../dashboard';
import users from '../users';
import mailEvents from '../mailEvents';
import paymentRequest from '../paymentRequest';
import cards from '../cards';
import villageConfig from '../villageConfig';
import villageTrip from '../villageTrip';
import clubSubscriptions from '../clubSubscriptions';
import villageScratchAndWin from '../villageScratchAndWin';
import villageGlobalGallery from '../villageGlobalGallery';
import videoReviews from '../videoReviews';
import pushNotifications from '../pushNotifications';
import villageActivities from '../villageActivities';
import clubVacationBookings from '../clubVacationBookings';
import parkedVacations from '../parkedVacations';
import agentSubscriptionRequests from '../agentSubscriptionRequests';
import agentSubscriptions from '../agentSubscriptions';
import operators from '../operators';
import faqNode from '../faqNode';
import walletTransaction from '../walletTransaction';
import clubVacationVoucher from '../clubVacationVoucher';
import photoPrintRequests from '../photoPrintRequests';
import pdfInterpolation from '../pdfInterpolation';
import pushSentLog from '../pushSentLog';

let routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import("./views/layout.vue"),
        children: [
            ...dashboard.routes,
            ...backendRoleConfig.routes,
            ...users.routes,
            ...operators.routes,
            ...commission.routes,
            ...walletTransaction.routes,
            ...deferredPayment.routes,
            ...clubSubscriptions.routes,
            ...clubVacationBookings.routes,
            ...clubVacationVoucher.routes,
            ...photoPrintRequests.routes,
            ...parkedVacations.routes,
            ...dictionary.routes,
            ...assistenzaNetwork.routes,
            ...assistenzaVillaggi.routes,
            ...mailSentLog.routes,
            ...network.routes,
            ...projectConfig.routes,
            ...purchase.routes,
            ...qualificationConfig.routes,
            ...shopOffer.routes,
            ...mailEvents.routes,
            ...paymentRequest.routes,
            ...faqNode.routes,
            ...cards.routes,
            ...villageConfig.routes,
            ...villageActivities.routes,
            ...villageTrip.routes,
            ...villageScratchAndWin.routes,
            ...villageGlobalGallery.routes,
            ...videoReviews.routes,
            ...agentSubscriptions.routes,
            ...agentSubscriptionRequests.routes,
            ...pushNotifications.routes,
            ...pdfInterpolation.routes,
            ...pushSentLog.routes
        ]
    }
];

export default routes;